import React from 'react';
import parse from 'html-react-parser';
import {
  StepGraphics,
  StepGraphicsHeading,
  StepGraphicsBody,
  StepGraphicsWrapper
} from '@ecs/tng-common/components/step-graphics/StepGraphics';
import Image from '@ecs/tng-common/components/image/Image';
import { formCTAurl, CTApath } from '@ecs/tng-common/scripts/registration';
import { ficoShort } from '@ecs/tng-common/documents/disclosures/regulatory';
import DisclosureWithSymbol from '@ecs/tng-common/components/disclosure-with-symbol/DisclosureWithSymbol';
import { IDisclosure } from '@ecs/tng-common/interfaces';
import {
  ISingleSteps,
  IStep,
  IStepIdValue,
  TypeCommonContent,
  typeCommonContent
} from '../../content/step-graphics';
import { ifCRMcampaign } from '../../helpers/analytics';
import { getAllParams } from '../../helpers/functions';

type StepGraphicsProps = {
  data: ISingleSteps;
  id: IStepIdValue;
  params: {
    categoryId?: number;
    postId?: number;
  };
};
type StepGraphicsState = {
  toUpdate: boolean;
  ctaText: string;
  ctaLink: string;
};
export default class StepGraphicsBlog extends React.Component<
  StepGraphicsProps,
  StepGraphicsState
> {
  common: TypeCommonContent = typeCommonContent[this.props.data.type];

  constructor(props: StepGraphicsProps) {
    super(props);
    this.state = {
      toUpdate: true,
      ctaText: this.common.ctaText,
      ctaLink: this.props.data.ctaUrl
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window?.location?.search);
      const pc = urlParams.get('pc');

      if (ifCRMcampaign(pc)) {
        this.setState({
          toUpdate: false,
          ctaText: this.common.ctaTextCRM,
          ctaLink: formCTAurl(
            {
              ...getAllParams()
            },
            CTApath.loginIndex
          )
        });
      }
    }
  }

  componentDidUpdate(prevProps: StepGraphicsProps, prevState: StepGraphicsState) {
    // to run opAppend if CTA is updated
    if (!this.state.toUpdate && prevState.toUpdate) {
      if (typeof window !== 'undefined' && window.opAppend) {
        window.opAppend();
      }
    }
  }

  render() {
    const { data, id } = this.props;
    let trackId: string = id;
    let disclosure: IDisclosure | null = null;
    const showStep = !['stepFCS', 'stepFCR'].includes(id);
    if (id === 'stepAuto-ins') {
      trackId = 'stepAI';
    }
    if (id === 'stepAuto-garage') {
      trackId = 'stepAG';
    }
    if (id === 'stepFCS') {
      disclosure = ficoShort;
    }
    return (
      <div className="border rounded content-mb overflow-hidden step-graphics-blog">
        <h3 className="h4 bg-coconut py-4 mb-0 px-3">{parse(data.title)}</h3>
        <StepGraphicsWrapper
          className="px-3 px-lg-0 pt-lg-4"
          id={id}>
          {data.steps.map((step: IStep, stepIndex: number) => {
            return (
              <StepGraphics
                key={`${id}step${stepIndex}`}
                defaultToggle={stepIndex === 0}>
                <StepGraphicsHeading
                  as="h4"
                  {...(showStep && { step: stepIndex + 1 })}>
                  {parse(step.title)}
                </StepGraphicsHeading>
                <StepGraphicsBody>
                  <p className="w-100">{parse(step.content)}</p>
                  <Image
                    src={`${this.common.assetPrefix}${step.imgSrc}`}
                    width="212"
                    height="185"
                    className="img-fluid w-lg-100 mx-auto"
                    alt={step.imgAlt}
                    lazyLoading
                  />
                </StepGraphicsBody>
              </StepGraphics>
            );
          })}
        </StepGraphicsWrapper>
        <div className="my-5 my-lg-6 text-center px-3">
          <a
            href={this.state.ctaLink}
            data-op="INL"
            data-link-both={`ae-cta-article-${trackId}-c${this.props.params.categoryId}-s${this.props.params.postId}`}
            className="btn btn-primary btn-min-width w-100 w-md-auto">
            {parse(this.state.ctaText)}
          </a>
        </div>
        {disclosure && (
          <div className="disclosures px-3 my-5 my-lg-6">
            <DisclosureWithSymbol disclosure={disclosure} />
          </div>
        )}
      </div>
    );
  }
}
